
import { sendErrorToSentry } from './helpers/sentry-helper';

const addressFinderAutocomplete = () => ({
    searchTerm: '',
    showResultBox: false,
    autoCompleteResults: [],
    solarPartnersCount: 0,

    init() {

        document.addEventListener('foundSolarPartners', (e) => {
            this.solarPartnersCount = e.detail.resultsCount
        })
    },

    addressFinderAutoComplete: function () {
        const searchTerm = this.searchTerm
        this.showResultBox = false
        fetch('/outages/search/' + encodeURIComponent(searchTerm), {
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        })
            .then(r => {
                if (!r.ok) {
                    sendErrorToSentry(new Error('Address Finder API returned an error'), {
                        status: r.status,
                        statusText: r.statusText,
                        url: r.url
                    });
                    return []; // Return an empty array to prevent JSON parsing error
                }
                return r.json();
            })
            .then(r => this.handleAddressResult(r))
            .catch(error => {
                sendErrorToSentry(error, {
                    context: 'Error fetching address autocomplete results'
                });
                this.autoCompleteResults = [];
                this.showResultBox = false;
            });
    },

    handleAddressResult: function (result) {
        if (result) {
            this.autoCompleteResults = result.map(e => {
                return [e.highlighted_a, e.pxid]
            })

            if (this.autoCompleteResults.length === 0 && this.solarPartnersCount === 0) {
                this.showResultBox = false
            } else {
                this.showResultBox = true
            }
        }
    },


    async selectResult(result) {
        if (result.length === 2) {
            await fetch('/outages/search-detail/' + encodeURIComponent(result[1]))
                .then(lookup => lookup.json())
                .then(lookup => {
                    result = [
                        lookup['postal'],
                        lookup['y'],
                        lookup['x'],
                        lookup['a'],
                    ]
                })
        }

        this.searchTerm = result[3]
        this.showResults = false

        this.$dispatch('selected', [result[1], result[2]])
    },

    input: {
        ['@focus']() {
            this.showResults = this.autoCompleteResults.length > 0
        },

        ['@click.away']() {
            this.showResultBox = false
        },

        ['x-model']: 'searchTerm',

        ['@keyup.debounce.500ms']() {
            this.addressFinderAutoComplete()
        }
    },

    resultBox: {
        ['x-show']() {
            return this.showResultBox
        },
    },

    searchIcon: {
        ['@click']() {
            this.addressFinderAutoComplete()
        },
    }
});

document.addEventListener('alpine:init', () => {
    Alpine.data('addressFinderAutocomplete', addressFinderAutocomplete)
});